import { TaskStatus, TaskType, TaskTypeV2 } from "../Types";
const canceledLessTaskStatusOptions = TaskStatus.options.filter((taskStatus) => taskStatus !== TaskStatus.enum.CANCELED);
export const taskTypeStatusMap = {
    ["all"]: TaskStatus.options,
    [TaskType.enum.ACCOUNT_OPENING]: TaskStatus.options,
    [TaskType.enum.ACCOUNT_MAINTENANCE]: TaskStatus.options,
    [TaskType.enum.ACCOUNT_TRANSFER]: TaskStatus.options,
    [TaskType.enum.TRADE_REQUEST]: TaskStatus.options,
    [TaskType.enum.ALTERNATIVE_INVESTMENT]: TaskStatus.options,
    [TaskType.enum.STANDING_INSTRUCTIONS]: canceledLessTaskStatusOptions,
    [TaskType.enum.MONEY_MOVEMENT]: canceledLessTaskStatusOptions,
    [TaskType.enum.LIQUIDATION]: TaskStatus.options,
    [TaskType.enum.OTHER]: TaskStatus.options,
};
export const taskTypeStatusMapV2 = {
    ["all"]: TaskStatus.options,
    [TaskTypeV2.enum.ACCOUNT_OPENING]: TaskStatus.options,
    [TaskTypeV2.enum.ACCOUNT_MAINTENANCE]: TaskStatus.options,
    [TaskTypeV2.enum.ACCOUNT_TRANSFER]: TaskStatus.options,
    [TaskTypeV2.enum.TRADE_REQUEST]: TaskStatus.options,
    [TaskTypeV2.enum.ALTERNATIVE_INVESTMENT]: TaskStatus.options,
    [TaskTypeV2.enum.STANDING_INSTRUCTIONS]: canceledLessTaskStatusOptions,
    [TaskTypeV2.enum.MONEY_MOVEMENT]: canceledLessTaskStatusOptions,
    [TaskTypeV2.enum.LIQUIDATION]: TaskStatus.options,
    [TaskTypeV2.enum.OTHER]: TaskStatus.options,
    [TaskTypeV2.enum.BUGS_AND_ENGINEERING_REQUESTS]: TaskStatus.options,
    [TaskTypeV2.enum.FINANCIAL_PLANNING]: TaskStatus.options,
    [TaskTypeV2.enum.IRA_ROLLOVERS]: TaskStatus.options,
    [TaskTypeV2.enum.BILLING]: TaskStatus.options,
    [TaskTypeV2.enum.CLIENT_REPORT]: TaskStatus.options,
};
const canceledLessTaskTypes = [
    TaskType.enum.STANDING_INSTRUCTIONS,
    TaskType.enum.MONEY_MOVEMENT,
];
const canceledLessTaskTypeOptions = TaskType.options.filter((taskType) => canceledLessTaskTypes.includes(taskType) === false);
const canceledLessTaskTypeOptionsV2 = TaskTypeV2.options.filter((taskType) => canceledLessTaskTypes.includes(taskType) === false);
export const taskStatusTypeMap = {
    ["all"]: TaskType.options,
    [TaskStatus.enum.NOT_STARTED]: TaskType.options,
    [TaskStatus.enum.IN_PROGRESS]: TaskType.options,
    [TaskStatus.enum.WAITING_ON_CLIENT]: TaskType.options,
    [TaskStatus.enum.WAITING_ON_ADVISOR]: TaskType.options,
    [TaskStatus.enum.WAITING_ON_THIRD_PARTY]: TaskType.options,
    [TaskStatus.enum.WAITING_ON_CUSTODIAN]: TaskType.options,
    [TaskStatus.enum.COMPLETED]: TaskType.options,
    [TaskStatus.enum.CANCELED]: canceledLessTaskTypeOptions,
};
export const taskStatusTypeMapV2 = {
    ["all"]: TaskTypeV2.options,
    [TaskStatus.enum.NOT_STARTED]: TaskTypeV2.options,
    [TaskStatus.enum.IN_PROGRESS]: TaskTypeV2.options,
    [TaskStatus.enum.WAITING_ON_CLIENT]: TaskTypeV2.options,
    [TaskStatus.enum.WAITING_ON_ADVISOR]: TaskTypeV2.options,
    [TaskStatus.enum.WAITING_ON_THIRD_PARTY]: TaskTypeV2.options,
    [TaskStatus.enum.WAITING_ON_CUSTODIAN]: TaskTypeV2.options,
    [TaskStatus.enum.COMPLETED]: TaskTypeV2.options,
    [TaskStatus.enum.CANCELED]: canceledLessTaskTypeOptionsV2,
};
//# sourceMappingURL=options.js.map